<script lang="ts">
  import Field from '../lib/ui/Field.svelte';
  import { ReportSchedule } from '../lib/report-schedule';
  import type { ReportScheduleDraft } from '../lib/report-schedule-draft.svelte';

  interface Props {
    draft: ReportScheduleDraft;
  }

  let { draft }: Props = $props();
</script>

<Field label="Repete a cada">
  <div class="interval">
    <input type="number" min="1" bind:value={draft.interval} aria-label="Quantidade" />
    <select bind:value={draft.unit} aria-label="Unidade">
      {#each ReportSchedule.units as option (option.value)}
        <option value={option.value}>{ReportSchedule.unitLabel(option, draft.interval)}</option>
      {/each}
    </select>
  </div>
</Field>
{#if draft.unit === 'week'}
  <fieldset class="days-box">
    <legend>Nos dias da semana</legend>
    <div class="weekdays">
      {#each ReportSchedule.weekdays as weekday (weekday.day)}
        <label class="check"><input type="checkbox" value={weekday.day} bind:group={draft.weekdays} /> {weekday.short}</label>
      {/each}
    </div>
  </fieldset>
{/if}
{#if draft.unit === 'month'}
  <fieldset class="days-box">
    <legend>Nos dias do mês</legend>
    <div class="month-days">
      {#each ReportSchedule.monthDays as day (day)}
        <label class="check"><input type="checkbox" value={day} bind:group={draft.monthDays} /> {day}</label>
      {/each}
    </div>
  </fieldset>
{/if}
<Field label="A partir de" hint="O primeiro envio é a primeira data da regra desde este dia">
  <input type="date" bind:value={draft.startsOn} />
</Field>
<Field label={draft.unit === 'hour' ? 'A partir das' : 'Hora'}>
  <input type="time" bind:value={draft.sendTime} />
</Field>
<div class="summary">
  <span class="label">Como fica escrito</span>
  <span class="name">{draft.schedule.describe()}</span>
  {#if draft.schedule.isMissingDays()}
    <span class="sub">Escolha ao menos um dia</span>
  {:else}
    <span class="sub">Próximos: {draft.nextSends.join(' · ')}</span>
  {/if}
</div>

<style>
  .days-box {
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    padding: var(--space-3) var(--space-4);
  }
  legend {
    font-size: 12px;
    color: var(--text-secondary);
    padding: 0 var(--space-1);
  }
  .interval {
    display: grid;
    grid-template-columns: 96px 1fr;
    gap: var(--space-2);
  }
  .weekdays {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-4);
  }
  .month-days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: var(--space-2);
  }
  .check {
    display: flex;
    align-items: center;
    gap: var(--space-2);
  }
  .check input {
    width: auto;
    padding: 0;
  }
  .summary {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .label {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  .name {
    color: var(--text-primary);
    font-weight: 500;
  }
  .sub {
    color: var(--text-tertiary);
    font-size: 12px;
  }
</style>
